<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-red-100 text-red-700"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "DangerBadge",
  props: ["label"],
};
</script>
